import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BackService } from '../../services/back-service/back.service';

@Component({
  selector: 'app-main-header',
  templateUrl: './main-header.component.html',
  styleUrls: ['./main-header.component.scss'],
})
export class MainHeaderComponent implements OnInit {
  @Input() pageTitle;
  @Input() showSearchbar;
  @Input() showTimePicker;
  @Input() asModal = false
  @Input() showSegments = false
  @Input() showBackButton = false
  @Output() performSearch = new EventEmitter<string>();
  @Output() performCloseModal = new EventEmitter<string>();
  searchbarQuery;
  isSearchbarExpanded;
  constructor(private backService:BackService) {}

  ngOnInit() {}

  toggleSearchbar() {
    this.isSearchbarExpanded = !this.isSearchbarExpanded;
  }

  goback() {
    this.backService.goBackToPrevious()
  }

  filter() {
    this.performSearch.emit(this.searchbarQuery);
  }

  closeModal() {
    this.performCloseModal.emit()
  }
}
